// Admin users configuration
export const ADMIN_EMAILS = [
  'kaleb.workneh@wholefoods.com',
  '2389302@wholefoods.com',
  'kalebzenawi@gmail.com',
  'kalebzworkneh@gmail.com'
];